
import companyService from '../services/company-service';
import { startLoading, endLoading } from './app-dux';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    activeCompany: null
};

/*******************************************************************************
 * Non-async action types
 */
export const SET_ACTIVE_COMPANY = 'COMPANY/SET_ACTIVE_COMPANY';

/*******************************************************************************
 * Reducer
 */
export default function companyReducer( state = initialState, action ) {
    switch ( action.type ) {     
        case SET_ACTIVE_COMPANY:
            return {
                ...state,
                activeCompany: action.activeCompany
            };
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
export function fetchActiveCompanyDetails( companyId ) {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return companyService.getCompany( companyId )
            .then( ( companyData ) => {
                dispatch( setActiveCompany( companyData || null ) );
            } )
            .catch( ( err ) => {
                console.log( 'Error while fetching active company details', err );
            } ).finally ( () => {
                dispatch( endLoading() );
            } );
    };
}

export function setActiveCompany( activeCompany ) {
    return {
        type: SET_ACTIVE_COMPANY,
        activeCompany
    };
}